const userTypes = {
  SET_CUSTOMERS: "SET_CUSTOMERS",
  SET_WARRIORS: "SET_WARRIORS",

  UPDATE_WARRIOR: "UPDATE_WARRIOR",
};

export default userTypes;
